export const CHAT_AGENT_COMPONENT = 'ChatAgentComponent';
